import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMeta from "vue-meta";
import VueSeamlessScroll from "vue-seamless-scroll";
import { API_KEY, isAuthRequired } from "@/config/apiConfig.js";

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);

// 對需認證的站台（fhy.wra.gov.tw 的 Api/v2 與 OpenApiv3）自動注入 apikey header
axios.interceptors.request.use((config) => {
  if (API_KEY && isAuthRequired(config.url)) {
    config.headers["apikey"] = API_KEY;
  }
  return config;
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VueSeamlessScroll);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
